import { render, staticRenderFns } from "./DetailsSpecItem.vue?vue&type=template&id=6111301c&scoped=true&"
import script from "./DetailsSpecItem.vue?vue&type=script&lang=js&"
export * from "./DetailsSpecItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSpecItem.vue?vue&type=style&index=0&id=6111301c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111301c",
  null
  
)

export default component.exports